<template>
  <div class="auth-wrapper">
    <!---Header outside of the card-->
    <div class="auth-container">
      <div class="auth-content-container">
        <div class="auth-header">
          <div class="auth-title">
            <span>
              {{ isBasicAvailable ? $t("billing.finish_payment_title_basic") : $t("auth.signup_to_get_started") }}
            </span>
          </div>
          <div class="auth-subtitle">
            {{
              isBasicAvailable
                ? $t("billing.finish_payment_subtitle_basic")
                : $t("auth.create_account") + ": " + $t("auth.current_step", { step: step, maxSteps: maxSteps })
            }}
          </div>
          <div class="auth-step-indicator">
            <div
              v-for="loopStep in maxSteps"
              :class="step >= loopStep ? 'primary' : ''"
              :key="loopStep"
              class="auth-step-indicator__line"></div>
          </div>
        </div>
      </div>
    </div>
    <!---Header outside of the card END-->

    <!--- Auth card -->
    <div class="auth-container">
      <div class="auth-content-container">
        <v-card class="auth-card">
          <VaDisclaimer
            v-if="errorMessages"
            class="error-disclaimer va-disclaimer--caption"
            :type="'error'"
            :icon-color="'error'"
            :text="errorMessages">
          </VaDisclaimer>
          <v-stepper class="stepper" elevation="0" v-model="step">
            <v-stepper-items>
              <!-- STEP 1 -->
              <v-stepper-content step="1">
                <v-form ref="form" validate-on="validate" @submit.prevent="submit">
                  <!--
                      Crazy fix for autofill Chrome & Safari
                      https://bugs.chromium.org/p/chromium/issues/detail?id=468153

                      F i x  start
                    -->
                  <input tabindex="-1" style="opacity: 0; position: absolute" />
                  <input tabindex="-1" type="password" style="opacity: 0; position: absolute" />
                  <div style="position: absolute; height: 0px; overflow: hidden">
                    Username <input tabindex="-1" type="text" name="fake_safari_username" /> Password
                    <input tabindex="-1" type="password" name="fake_safari_password" />
                  </div>
                  <!-- F i x  over -->
                  <div class="text-center">
                    <GoogleLoginModule />
                  </div>

                  <div class="auth-divider-wrapper">
                    <div class="auth-divider"></div>
                    <div>or</div>
                    <div class="auth-divider"></div>
                  </div>
                  <div class="register-name-wrapper" v-if="showFullRegistration">
                    <v-text-field
                      ref="firstName"
                      :label="$t('auth.first_name')"
                      :rules="[rules.required, rules.min]"
                      :placeholder="$t('auth.first_name')"
                      v-model="form.firstName"
                      validate-on-blur
                      persistent-placeholder
                      hide-details="auto"
                      @blur="trackStep1($refs.firstName)"
                      required>
                      <template v-slot:message="{ message }">
                        <v-icon size="16" color="error">{{ icons.mdiAlertCircle }}</v-icon>
                        {{ message }}
                      </template>
                    </v-text-field>
                    <v-text-field
                      ref="lastName"
                      :label="$t('auth.last_name')"
                      :rules="[rules.required, rules.min]"
                      :placeholder="$t('auth.last_name')"
                      v-model="form.lastName"
                      validate-on-blur
                      persistent-placeholder
                      hide-details="auto"
                      @blur="trackStep1($refs.lastName)"
                      required>
                      <template v-slot:message="{ message }">
                        <v-icon size="16" color="error">{{ icons.mdiAlertCircle }}</v-icon>
                        {{ message }}
                      </template>
                    </v-text-field>
                  </div>
                  <div class="spacing-top--24" v-if="showFullRegistration">
                    <v-text-field
                      ref="email"
                      :label="$t('auth.email')"
                      :rules="[rules.required, rules.email]"
                      class="email-input"
                      :placeholder="$t('auth.email')"
                      persistent-placeholder
                      type="email"
                      v-model="form.email"
                      validate-on-blur
                      hide-details="auto"
                      :error-messages="errors.email"
                      @blur="trackEmail($refs.email)"
                      required>
                      <template v-slot:message="{ message }">
                        <v-icon size="16" color="error">{{ icons.mdiAlertCircle }}</v-icon>
                        {{ message }}
                      </template>
                    </v-text-field>
                  </div>
                  <div class="spacing-top--24">
                    <PasswordAndPasswordRepeatBlock
                      v-model="form.password"
                      v-if="showFullRegistration"
                      :onBlur="trackStep1" />
                  </div>
                  <div class="spacing-top--24">
                    <phone-input ref="phoneNumber" v-model="form.phoneNumber" @blur="onPhoneBlur" />
                  </div>
                  <!--
                    Prevents the auto-filling of phone number input, also
                    suggests correct username to be saved by the "save password?" prompt
                    (firefox suggests correct username, chrome includes the value of the below input as one of the options
                    to be saved as a username)
                  -->
                  <input
                    name="username"
                    :value="form.email"
                    style="opacity: 0; width: 1px; height: 1px; position: absolute"
                    tabindex="-1" />

                  <v-btn color="primary" :loading="loading" @click="submit()" x-large class="auth-btn spacing-top--24">
                    {{ $t("auth.get_started") }}
                  </v-btn>
                  <div class="text-center login-helper">
                    {{ $t("auth.login_helper") }}
                    <router-link to="/login">{{ $t("auth.login") }}</router-link>
                  </div>
                  <div class="register-disclaimer">
                    <div>
                      {{ $t("auth.disclaimer_1") }}
                    </div>
                    <div>
                      <a
                        class="register-disclaimer-link"
                        target="_blank"
                        :href="'https://' + appDomain + '/terms-of-use'"
                        >{{ $t("auth.disclaimer_2") }}</a
                      >
                      {{ $t("auth.disclaimer_3") }}
                      <a
                        class="register-disclaimer-link"
                        target="_blank"
                        :href="'https://' + appDomain + '/privacy-policy'">
                        {{ $t("auth.disclaimer_4") }}
                      </a>
                    </div>
                  </div>
                </v-form>
              </v-stepper-content>
              <!-- STEP 1 END -->
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  //vuex
  import store from "@/store";
  //icon
  import { mdiAlertCircle } from "@mdi/js";
  // Composable
  import useAppConfig from "@core/@app-config/useAppConfig";
  import themeConfig from "@themeConfig";
  // utils
  import { validateEmail } from "@/assets/utilities/helpers/email";
  // components
  import GoogleLoginModule from "@/components/custom/Auth/GoogleLoginModule.vue";
  import PasswordAndPasswordRepeatBlock from "@/components/custom/PasswordAndPasswordRepeatBlock.vue";
  import VaDisclaimer from "@/components/custom/VaDisclaimer.vue";
  import PhoneInput from "@/components/custom/PhoneInput.vue";
  // directives
  import { mixpanelWrapper } from "@/@core/libs/mixpanel";
  // constants
  import { PAYMENT_DISCOUNTS } from "@/constant";
  import definedAbility from "@/ability";
  import { PAYMENT_PLANS } from "@/constant";

  export default {
    components: {
      GoogleLoginModule,
      PasswordAndPasswordRepeatBlock,
      VaDisclaimer,
      PhoneInput,
    },
    props: {
      userData: {
        type: Object,
        required: false,
      },
    },
    data() {
      const { appSkinVariant } = useAppConfig();

      return {
        validateEmail,
        appSkinVariant,
        endpoints: {
          register: "/auth/register",
          completeRegister: "/auth/register/complete",
        },
        appDomain: themeConfig.app.domain,
        endpointToUse: "/auth/register",
        icons: {
          mdiAlertCircle: mdiAlertCircle,
        },
        appName: themeConfig.app.name,
        appLogo: themeConfig.app.logo,
        email: "",
        step: 1,
        maxSteps: 2,
        form: {
          email: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
          password: "",
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Vilnius",
        },
        showFullRegistration: true,
        loading: false,
        rules: {
          required: value => !!value || this.$t("generic.validation.required"),
          min: value => value.length >= 3 || this.$t("generic.validation.minimum_3_characters"),
          email: value => !!validateEmail(value) || this.$t("generic.validation.email"),
        },
        errorMessages: "",
        accountInformationTracked: false,
        emailTracked: false,
        errors: {},
      };
    },
    computed: {
      isBasicAvailable() {
        return this.$store.state?.billingPlan?.toUpperCase() === PAYMENT_PLANS.BASIC.name.toUpperCase();
      },
    },
    mounted() {
      // TODO: Prefill data if user comes from google callback;
      // If user data is passed from google callback, prefill the form
      this.resolveEndpointAndPrefillValues();
      this.$store.commit("SET_BILLING_PLAN", this.$route.query.plan || "");

      if (this.$route.query.discounts) {
        const discounts = Array.isArray(this.$route.query.discounts)
          ? this.$route.query.discounts
          : this.$route.query.discounts?.split(",");

        const validDiscounts = discounts
          .map(discount => PAYMENT_DISCOUNTS[discount.toUpperCase()])
          .filter(item => item);

        this.$store.commit("SET_PAYMENT_DISCOUNTS", validDiscounts);
      } else {
        this.$store.commit("SET_PAYMENT_DISCOUNTS", []);
      }

      setTimeout(() => {
        document.querySelector(".v-stepper").style.overflow = "visible";
        document.querySelector(".v-stepper__items").style.overflow = "visible";
      }, 400);
    },
    destroyed() {
      document.querySelector(".v-stepper").style.overflow = "hidden";
      document.querySelector(".v-stepper__items").style.overflow = "hidden";
    },
    methods: {
      onPhoneBlur() {
        this.trackStep1(null, true);
      },
      resolveEndpointAndPrefillValues() {
        if (this.userData) {
          store.dispatch("SET_USER_DATA", this.userData);
          this.showFullRegistration = false;
          this.endpointToUse = this.endpoints.completeRegister;
          this.step = 1;
          this.drip.push([
            "identify",
            {
              email: this.userData.email,
              step: 1,
              tags: ["Incomplete Registration"],
            },
          ]);
        }
      },
      async submit() {
        if (this.$refs.form.validate() & this.$refs.phoneNumber.validate()) {
          this.loading = true;
          try {
            let response;
            // If user is completing google registration instead of doing full one
            if (this.userData) {
              response = await this.$admin.dataProvider.customHttpCall("POST", "auth/register/complete", {
                phoneNumber: this.form.phoneNumber,
                timezone: this.form.timezone,
              });
              if (response) {
                const { user } = response.data;
                store.dispatch("SET_USER_DATA", user);
                mixpanelWrapper.track("Account Information Filled", {
                  previousPage: store.getters["getPreviousRoute"],
                });

                this.$router.push({ name: "billing" });
              }
            } else {
              response = await this.$admin.dataProvider.customHttpCall("POST", "auth/register", {
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                phoneNumber: this.form.phoneNumber,
                email: this.form.email,
                password: this.form.password,
                timezone: this.form.timezone,
              });
              if (response) {
                this.drip.push([
                  "identify",
                  {
                    email: this.form.email,
                    step: 1,
                    tags: ["Incomplete Registration"],
                  },
                ]);

                if (definedAbility().can("use", "google tag manager")) {
                  window.gtag && window.gtag("event", "conversion", { send_to: "AW-16455619013/tHinCIT_8K8ZEMWj06Y9" });
                }

                this.$store.dispatch("SET_USER_DATA", response.data.user);
                this.$router.push({ name: "billing" });
              }
            }
          } catch (e) {
            this.errors = e?.errors;
            if (!e?.errors) {
              this.errorMessages = e?.message || this.$t("generic.error");
            }

            this.loading = false;
          } finally {
            this.loading = false;
          }
        }
      },
      trackEmail(field) {
        if (!field.validate() || this.emailTracked) return;
        mixpanelWrapper.track("Credentials Filled", { previous_page: store.getters["getPreviousRoute"] });
        this.emailTracked = true;
      },
      trackStep1(field, phoneField = false) {
        if (this.accountInformationTracked) return;

        if (phoneField || field.validate()) {
          mixpanelWrapper.track("Account Information Filled", { previous_page: store.getters["getPreviousRoute"] });
          this.accountInformationTracked = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .auth-wrapper {
    width: 100%;

    &::v-deep {
      .v-stepper__wrapper {
        overflow: visible;
      }
    }
    a {
      text-decoration: unset;
    }
  }
  .auth-container {
    display: flex;
    justify-content: center;
    padding: 4px;
    @media (min-width: 600px) {
      padding: 0;
    }
    .auth-content-container {
      width: 100%;
      @media (min-width: 600px) {
        width: 398px;
      }
    }
  }

  .auth-card {
    padding: 14px;
    border-radius: 6px;
    @media (min-width: 600px) {
      padding: 22px;
    }
    &::v-deep {
      .v-stepper {
        border: none !important;
      }
      .v-stepper__content {
        padding: 0;
      }
    }

    .login-helper {
      margin-top: 16px;
      @include text-caption();
      color: get-color("headline");
    }

    .auth-divider-wrapper {
      @include text-caption();
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: 24px 0;
      @media (min-width: 600px) {
        margin: 24px 0;
      }
    }

    .auth-divider {
      height: 1px;
      border-radius: 4px;
      width: 35%;
      background: get-color("border");
    }
    .auth-btn {
      @include text-button-medium();
      background-color: get-color("primary");
      width: 100%;
      color: white;
      padding: 12px 54px;
      border-radius: 4px;

      &:hover {
        background-color: get-color("primary-hover");
      }
      &--signup {
        margin: 24px 0 16px;
      }
    }
  }

  .auth-header {
    margin-bottom: 24px;
    @media (min-width: 600px) {
      margin: 32px 0;
    }
    .auth-title {
      @include heading-4();
      color: get-color("headline");
      margin-bottom: 4px;
      @media (min-width: 600px) {
        @include heading-3();
      }
    }
    .auth-subtitle {
      @include text-body-2();
      color: get-color("subtitle");
      margin-bottom: 16px;
    }
    .auth-step-indicator {
      display: flex;
      gap: 20px;
      &__line {
        height: 5px;
        border-radius: 4px;
        background: get-color("primary-20");
        flex: 1;
      }
    }
  }

  .error-disclaimer {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 24px;
    @media (min-width: 800px) {
      margin-bottom: 32px;
    }
  }

  .stepper {
    ::v-deep .v-stepper__wrapper {
      padding: 0 10px;
    }
  }

  .register-name-wrapper {
    display: flex;
    gap: 12px;
  }

  .register-disclaimer {
    @include text-caption();
    color: get-color("subtitle");
    text-align: center;
    margin-top: 24px;
  }

  .register-disclaimer-link {
    @include text-caption();
    color: get-color("subtitle");
    text-decoration: underline !important;
  }
</style>
